import { ShippingMethod } from "@/apps/shared/proposal/core/domain/model/ShippingMethod";
import { PaymentMethod } from "@/apps/shared/proposal/core/domain/model/PaymentMethod";
import { Modifier } from "@/apps/shared/proposal/core/domain/model/Modifier";
import {
  ModifierResponse,
  PaymentMethodResponse,
  ShippingMethodResponse,
} from "@/apps/shared/proposal/core/infrastructure/checkoutMethodsRepository";

export class CheckoutMethodsMapper {
  static mapShippingMethod(shippingMethod: ShippingMethodResponse, paymentMethods: PaymentMethodResponse[]) {
    return new ShippingMethod(
      shippingMethod.id,
      shippingMethod.channel,
      shippingMethod.type,
      shippingMethod.description,
      this.mapModifier(shippingMethod.modifier),
      shippingMethod.available_payment_method_ids
        ?.map((paymentMethodId: string) => {
          const paymentMethod = paymentMethods.find((paymentMethod) => paymentMethod.id === paymentMethodId);
          return paymentMethod ? this.mapPaymentMethod(paymentMethod) : null;
        })
        .filter(Boolean) as PaymentMethod[],
      shippingMethod.available_countries
    );
  }

  static mapPaymentMethod(paymentMethod: PaymentMethodResponse) {
    return new PaymentMethod(
      paymentMethod.id,
      paymentMethod.type,
      paymentMethod.description,
      paymentMethod.long_description,
      this.mapModifier(paymentMethod.modifier),
      paymentMethod.label
    );
  }

  static mapModifier(modifier: ModifierResponse) {
    if (!modifier) {
      return null;
    }

    return new Modifier(modifier.type, modifier.value, modifier.capped_amount);
  }

  static mapCartShippingMethod(shippingMethod: any) {
    return new ShippingMethod(
      shippingMethod.id,
      shippingMethod.channel,
      shippingMethod.type,
      shippingMethod.description,
      this.mapCartModifier(shippingMethod.modifier),
      shippingMethod.paymentMethods,
      shippingMethod.availableCountries
    );
  }

  static mapCartPaymentMethod(paymentMethod: any) {
    return new PaymentMethod(
      paymentMethod.id,
      paymentMethod.type,
      paymentMethod.description,
      paymentMethod.longDescription,
      this.mapCartModifier(paymentMethod.modifier)
    );
  }

  static mapCartModifier(modifier: any) {
    if (!modifier) {
      return null;
    }

    return new Modifier(modifier.type, modifier.value, modifier.cappedAmount);
  }
}
